import React, { useEffect, useState, useRef, useCallback } from 'react'
import Grid from '@material-ui/core/Grid';
import { Button, Card, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import styles from './components/index.module.css'
import ImputComponent from "../InputComponent"
import SearchIcon from '@material-ui/icons/Search';
import SearchDebounceBar from '../SearchDebounce';
import { PropertySearch } from '../../factories/propertySearchs';
import PopUp from '@components/ui/PopUp';
import './RoomsAmenities.scss'
import { getAmenitiesForAllGuestRooms, getGuestrooms } from './components/Amenities/helpers'
import noData from 'Styles/assets/NoData.png'
import CreateAmenity from './components/CreateAmenity'
import EditAmenity from './components/EditAmenitie'
import DeleteAmenitie from './components/DeleteAmenitie'
import Loading from '../Loading'
import { sortHelper } from '../../helpers/misc/sortHelper'
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
  description: string;
}

interface propsTypes {
  isEditable?: void | any,
  cancelEditable?: void | any,
  setOperation?: void | any
  operationFlag?: any
  setCurrentRow?: void | any
  currentRow?: any
  setDefKey: (e: string) => void
  setSingleAmenity: (e: string) => void
  singleAmenity?: string
}

const RoomAmenities = (props: propsTypes) => {

  const [searchs, setSearch] = useState<string[]>([]);
  const [dataSource, setDataSource] = useState<object[] | any>([]);
  const [data, setData] = useState(dataSource);
  const [total, setTotal] = useState(dataSource.length);
  const [visible, setVisible] = useState(false);
  const [visibleEdition, setVisibleEdition] = useState(false);
  const [visibleDeletion, setVisibleDeletion] = useState(false);
  const [ready, setReady] = useState(false)
  const [guestRoomData, setGuestRoomData] = useState<object[] | any>([])
  const [editData, setEditData] = useState<any>({})
  const [deleteData, setDeleteData] = useState<any>({})
  const [paginationData, setPaginationData] = useState<number>(10)

  const columns: ColumnsType<DataType> | any = [
    {
      title: '',
      key: 'index',
      // @ts-expect-error
      render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
      width: '40px'
    },
    { 
      title: 'Amenity Name', 
      dataIndex: 'amenityType', 
      key: 'amenityType',
      onCell: (record: { amenityType: string }, index: number) => {
        return {
            onClick: (ev: any) => {
              // edit mode
              setEditData(record)
              setVisibleEdition(true)
            }, 
        };
      },
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'amenityType'),
      showSorterTooltip: false,
      render: (text: string) => (
        <>
            <span style={{ color: '#06789D', cursor: 'pointer' }}>
                {text}
            </span>
        </>
      ) 
      },
    {
      title: 'Amenity ID', 
      dataIndex: 'amenityID', 
      key: 'amenityID',
    },
    {
      title: 'Amenity Detail', 
      dataIndex: 'details', 
      key: 'details',
    },
    {
      title: 'Included in Rate', 
      dataIndex: 'includedInRates', 
      key: 'includedInRates',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center' as 'center',
      render:(text: string, record: any, index: number) => (
          <PopUp 
          trigger='click'
          color='white'
          placement="bottomRight"
          data={props.currentRow}
          opts={
            [
              {title:'Edit', action: () => {
                setEditData(record)
                setVisibleEdition(true)
              }},
              {title:'Delete', action:() => {
                setDeleteData(record)
                setVisibleDeletion(true)
              },
              data: record},
            ]
          } />
      )
    },
  ];

  /* const guestRoomsColumns: ColumnsType<DataType> | any = [
    { title: 'guestroom', dataIndex: 'guestroom', key: 'guestroom' },
    Table.SELECTION_COLUMN,
    {
      title: 'All', 
      dataIndex: 'middleTitle', 
      key: 'middleTitle',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center' as 'center',
      render:(text: string, record: [], index: number)=>(
          <PopUp 
          trigger='click'
          color='white'
          placement="bottomRight"
          data={props.currentRow}
          opts={
            [
              {title:'View', action: () => {}},
              {title:'Edit', action:() => {}},
              {title:'Delete', action:() => {},
              data: record},
            ]
          } />
      )
    },
  ]
 */

  const initialRender = useRef(true);
  const onChangeSearch = (term: string) => {
    setSearchTerm(term)
    onDebounce(term)
  }

  const filterData = async (query: string) => {
      const filterData = data.filter((item: any) => {
          const newFilterData: any = {}
          columns.forEach((col: any) => {
              newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] === undefined) ? '' : JSON.stringify(item[col.dataIndex]).toLowerCase();
          })
          return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;
      })
      setDataSource(filterData);
  }

  const recoverSearch = (search: string) => {
    setSearchTerm(search)
    filterData(search)
    onDebounce(search)
  } 

  const {
    searchTerm, setSearchTerm, searchTermDebounced, onDebounce
  } = SearchDebounceBar()

  const recentlySearchs = () => {
      return searchs.map((search, index) => {
          return (
              <span key={index} onClick={() => recoverSearch(search)}>
                  &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
              </span>
          )
      })
  }

  const saveNewSearch = (term: string) => {
    const stackSearchs = new PropertySearch(searchs)
    setSearch(stackSearchs.add(term))
  }

  const afterDebounce = (term: string) => {
    if (term) {
        saveNewSearch(term)
    }
    filterData(term)
  }

  useEffect(() => {
    if (initialRender.current) {
        initialRender.current = false;
    } else {
        afterDebounce(searchTermDebounced);
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [searchTermDebounced])

  const getPaginationData = useCallback(async () => {
    return await getPaginationSession(
        setPaginationData,
        'room_amenities'
    );
  }, [])

  const getData = useCallback(
    async () => {
      const { guestRoomAmenitiesForAllRooms } = await getAmenitiesForAllGuestRooms()
      guestRoomAmenitiesForAllRooms.map((amenitie: any, index: number) => {
        return amenitie.key = index
      })
      const { property: { guestrooms: { guestroom }}} = await getGuestrooms()

      setDataSource(guestRoomAmenitiesForAllRooms)
      setData(guestRoomAmenitiesForAllRooms)
      setGuestRoomData(guestroom)
      await getPaginationData();
      setReady(true)
    }, [])

  useEffect(() => {
    getData()
  }, [getData])

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    setVisibleEdition(false)
    setVisibleDeletion(false)
  };

  const reload = () => {
    setReady(false)
    getData();
  }

  return (
    <>
    <div className={styles.tableContent}>
    {!ready && <Loading type={'large'} />}
      {ready && 
      <Card>
        <Grid container spacing={0} className="containerSpacing py-0">
          <Grid item xs={12} className="p-0">
              <div className={styles.guestRoomTitle}>
                  <div style={{ fontWeight: 'bold' }}>Room Amenities</div>
                  <div>
                      <Button className="db-add-btn" style={{ width: 88, height: 32 }} onClick={showDrawer}> Create</Button>
                  </div>
              </div>
          </Grid>
          <Grid item xs={4} className="pb-0 px-0 my-0">
              <ImputComponent
                  className='SearchBar'
                  label={'Search'}
                  labelShrink={true}
                  value={searchTerm}
                  onChange={onChangeSearch}
                  placeholder='Search Room Amenities'
                  endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
              />
              <div className="recentlySearchs">
                  <p>{'Recently searched'}: {recentlySearchs()}</p>
              </div>
          </Grid>
          <Grid item xs={12} className="p-0">
            <Table
              columns={columns}
              locale={{ emptyText: (
                <>
                <img src={noData} alt='no data' style={{ marginTop: 56, marginBottom: 24 }} />
                <div style={{ fontSize: 16, color: '#333333' }}>No amenitites have been created. <br/> Please add amenities to the Amenities section.</div>
                <Button className="db-add-btn" style={{ width: 150, height: 40, marginTop: 33, marginBottom: 90 }} onClick={showDrawer}> Create Amenity </Button>
                </>
              )
               }}
              /* rowSelection={{}}
                expandable={{
                expandedRowRender: (record) => { return (
                  <div
                    style={{
                      margin: 0,
                    }}
                  >
                    <Table
                      columns={guestRoomsColumns}
                      rowSelection={{}} 
                      pagination={false}
                      showHeader={true} 
                      dataSource={record.guestrooms.filter((guest : any) => guest.selected)}
                      expandable={{
                        expandedRowRender: record => record,
                        rowExpandable: () => false 
                      }}
                      rowClassName='sub_table'
                    />
                  </div>
                )},
                rowExpandable: record => record.name !== 'Not Expandable'
              }} */
              dataSource={dataSource}
              pagination={{
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
                showTotal: (total, range) => `Total ${total} items, current ${range[0]}-${range[1]}`,
                defaultPageSize: paginationData,
                defaultCurrent: 1,
                onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'room_amenities': size }),
                size: "small",
                total
              }}
            />
          </Grid>
        </Grid>
      </Card>}
      <CreateAmenity
        onClose={onClose}
        visible={visible}
        setOperation={props.setOperation}
        setCurrentRow={props.setCurrentRow}
        setDefKey={props.setDefKey}
        setSingleAmenity={props.setSingleAmenity}
        reload={reload}
      />
      <EditAmenity
        editData={editData}
        onClose={onClose}
        visible={visibleEdition}
        setOperation={props.setOperation}
        setCurrentRow={props.setCurrentRow}
        setDefKey={props.setDefKey}
        setSingleAmenity={props.setSingleAmenity}
        reload={reload}
      />
      <DeleteAmenitie
        deleteData={deleteData}
        onClose={onClose}
        visible={visibleDeletion}
        setOperation={props.setOperation}
        setCurrentRow={props.setCurrentRow}
        setDefKey={props.setDefKey}
        setSingleAmenity={props.setSingleAmenity}
        reload={reload}
      />
    </ div>
    </>
  )
}

export default RoomAmenities
